import * as type from './type';
export default {
    [type.SET_PERSONAL_INFO](state, personalInfo) {
        state.personalInfo = personalInfo;
    },

    [type.SET_BILLING_INFO](state, billingInfo) {
        state.billingInfo = billingInfo;
    },

    [type.SET_COMPANY_INFO](state, companyInfo) {
        state.companyInfo = companyInfo;
    },

    [type.SET_CORPORATE_PERSON_INFO](state, corporatePersonInfo) {
        state.corporatePersonInfo = corporatePersonInfo;
    },

    [type.SET_REFUND_INFO](state, refundInfo) {
        state.refundInfo = refundInfo;
    },

    [type.SET_PARENT_COMPANY_LISTS](state, lists) {
        state.parentCompanyLists = lists;
    },

    [type.SET_SUB_COMPANY_LISTS](state, lists) {
        state.subCompanyLists = lists;
    },

    [type.SET_PARENT_COMPANY_BY_SEARCH](state, parentCompany) {
        state.parentCompanyBySearch = parentCompany;
    },

    [type.SET_VAT_INFO](state, vatInfo) {
        state.vatInfo = vatInfo;
    },

    [type.SET_VAT_DETAIL](state, vatDetail) {
        const {agencyInfo:{name}, vats:{id, taxpayerNumber, registeredPhone, registeredAddress, bankName, bankAccount, taxBoard, taxpayerForm, rejectReason}} = vatDetail;
        state.vatDetail = Object.assign({}, this.state.personalCenter.vatDetail, {id, name, taxpayerNumber, registeredPhone, registeredAddress, bankName, bankAccount, taxBoard, taxpayerForm,rejectReason});
    },

    [type.SET_AGENCY_INFO](state, agencyInfo) {
        const {name, taxpayerNumber} = agencyInfo;
        state.vatDetail = Object.assign({},
            {id: null, name: '', taxpayerNumber: '', registeredPhone: '', registeredAddress: '', bankName: '', bankAccount: '', taxBoard: '', taxpayerForm: ''},
            {name, taxpayerNumber});
    },

    //设置卖家一级品类
    [type.SET_SELLER_FIRST_CATEGORIES](state, sellerFirstCategories) {
        state.sellerFirstCategories = sellerFirstCategories;
    },

    //开通卖家选择的售卖品类
    [type.OPEN_SELLER_SELECTED_CATEGORIES](state, selectedCategoryList) {
        state.selectedCategoryList = selectedCategoryList;
    }
}


// WEBPACK FOOTER //
// ./src/store/personal-center/mutations.js